export const DeskTop = '1024px';
export const Tablet = '768px';
export const MagazineTablet = '1180px';
export const Fold = '280px';
export const PCContentArea = '1090px';
